export default __webpack_public_path__ + "static/media/professor.4a833e53.svg";